module.exports = __webpack_public_path__ + "static/media/MW_Logo_horizontal_navy.7ab4af0b.svg";